<template>
  <blocked-content-wrapper :blocked="blocked" class="home-container mb-5">
    <static-block-component page="event" position="top"/>
    <div v-if="event && event.participants ">
      <div class="d-flex justify-content-center mt-3 align-items-center teams-images-wrapper">
        <template v-if="event.participants.length === 2">
          <div class="team-img" v-if="teams.awayTeam.img">
            <image-component :path="teams.awayTeam.img" :alt="teams.awayTeam.name"/>
          </div>
          <div class="team-img" v-if="teams.homeTeam.img">
            <image-component :path="teams.homeTeam.img" :alt="teams.homeTeam.name"/>
          </div>
        </template>
        <template v-else>
          <div class="img-wrapper d-flex justify-content-center align-items-center"
               :class="{
                  small: event.stream_status !== $options.STREAM_STATUS.upcoming
               }"
               @click.stop.prevent="embeddedPreview && !showEmbeddedPreview && togglePreview(true)"
          >
            <image-component v-if="eventImage" class="event-img" :path="eventImage" alt="banner"/>
            <button-component
              v-if="embeddedPreview && !showEmbeddedPreview"
              variant="icon"
              class="play-preview d-flex align-items-center justify-content-center"
              @btn-click="togglePreview(true)"
            >
              <div class="play-icon">
                <play-icon/>
              </div>
            </button-component>
          </div>
        </template>
      </div>
      <div class="p-2 watch-title-wrapper" :style="watchTitleStyle">
        <template v-if="event.participants?.length === 2">
          <div class="sport-icon">
            <sport-icons v-if="sport" :sport="sport"/>
          </div>
          <favorite-star-toggle
            :favorite="teams.awayTeam"
            :type="$options.FAVORITES_TYPE.participant"
            class="teams-star away-team"
          />
        </template>
        <span class="watch-title">{{ videoTitle }}</span>
        <template v-if="event.participants?.length === 2">
          <favorite-star-toggle
            :favorite="teams.homeTeam"
            :type="$options.FAVORITES_TYPE.participant"
            class="teams-star home-team"
          />
          <div v-if="gender" class="gender-icon" :class="gender">
            {{ gender }}
          </div>
        </template>
      </div>
      <div class="pb-2 px-2 watch-details-wrapper">
        <div class="gap-025 watch-date">
            <div class="calendar-icon d-inline-flex">
              <calendar-icon/>
            </div>
            {{ formattedTime.month }} {{ formattedTime.day }}
            &#183;
            {{ formattedTime.hh }} {{ formattedTime.zone }}
        </div>
        <span v-if="location" class="gap-025 watch-location">
          <location-icon/>
          {{ location }}
        </span>
        <span class="watch-id">
          ID: {{ event.id }}
        </span>
      </div>
      <div></div>
      <div v-if="loading">
        <loader-component/>
      </div>
      <div v-else class="player_wrapper">
        <div class="player-container" v-if="!event.is_geo_blocked">
          <template v-if="eventUpcoming">
            <div class="flip-section">
              <p>{{ $t('Broadcast starts in') }}:</p>
              <time-flip @timeEnded="onTime"
                         :timestamp="event.event_utc_ts" :countDownPreview="countDownPreview"/>
            </div>
          </template>
          <template v-else>
            <player-controller
              v-if="!embedded"
              :options="videoOptions"
              :event="event"
              :analytics-options="analyticsOptions"
              @interface="onInterfaceGet"
              @play="onPlayChange"
              :sport="sportName"
              :teams="teams"
            />
            <div v-else v-html="embedded"></div>
            <div class="d-flex justify-content-end my-3 align-items-start gap-1 flex-wrap">
              <download-button
                v-if="canDownloadEvent"
                :api-method="downloadEvent"
                :id="event.id"
                class="d-flex mr-auto"
                :onRequestFinish="getEventInfo"
              />
              <select-component
                v-if="showStreamList"
                :options-list="streamsList"
                :selectedValue="selectedStream.id"
                @update:selectedValue="selectNewStream"
                prop-for-value="id"
                prop-for-name="title"
                class="stream-list"
                :with-empty="false"
              >
                <template v-slot:default="{option}">
                  <div class="d-flex justify-content-between w-100 px-2">
                    <span>{{ $t(option.title) }}</span>
                  </div>
                </template>
              </select-component>
              <button-component
                v-if="chatIsEnabled"
                @btn-click="toggleChat"
                class="chat-toggle-btn"
              >
                {{ $t(chatDisplayed ? 'Hide chat' : 'Show chat') }}
              </button-component>
              <button-component
                v-if="scoreEnabled"
                @btn-click="toggleScore"
                class="score-toggle-btn"
              >
                {{ $t(showScore ? 'Hide Score' : 'Show Score') }}
              </button-component>
              <tutorial-caller
                v-if="needCutClip && playerInterface"
                name="clipping_button"
                positioned="bottom-right"
              >
                <template v-slot:default="{finishTutorial}">
                  <button-component
                    @btn-click="toggleClipsComponent"
                    @click.native="finishTutorial"
                    title="CLIP.Clip"
                  >
                    {{ $t('CLIP.Clip') }}
                  </button-component>
                </template>
              </tutorial-caller>
            </div>
          </template>
        </div>
        <clip-cut-component
          v-if="needCutClip && playerInterface && isClipsDisplayed"
          :playerInterface="playerInterface"
          :video-play="videoPlaying"
          :event="event"
          :sportType="sportTagsName"
          :on-clip-creat-requested="getEventInfo"
          :stream-id="selectedStream.id"
        />
        <template v-if="chatIsEnabled">
          <div v-show="chatDisplayed" class="chat">
            <chat-component :event="event"/>
          </div>
        </template>
      </div>

    </div>

    <div v-show="scoreEnabled && showScore" class="player_wrapper mt-5">
      <div class="container" v-html="scoreEnabled"></div>
    </div>
    <static-block-component page="event" position="bottom"/>
    <div v-if="showEmbeddedPreview"
         class="embeddeb-preview"
         @click.stop.prevent="togglePreview(false)"
    >
      <div class="content">
        <button-component
          variant="icon"
          class="closeIcon"
          @btn-click="togglePreview(false)"
        >
          <XMarkIcon/>
        </button-component>
        <embedded-player :link="embeddedPreview" :autoplay="true" class="preview-player"/>
      </div>
    </div>
  </blocked-content-wrapper>
</template>

<script>
import WatchScreen from '@/league/views/WatchScreen';
import TutorialCaller from '@/components/onboarding/TutorialCaller.vue';
import LocationIcon from '@/assets/img/locationIcon.vue';
import SelectComponent from '@/components/base-components/customSelect/SelectComponent.vue';
import {PLAYER_ACTIONS, PLAYER_EVENTS} from '@/const';

export default {
  name: 'WatchGameScreen',
  components: {
    LocationIcon,
    TutorialCaller,
    SelectComponent,
  },
  extends: WatchScreen,
  data() {
    return {
      selectedStream: null,
    };
  },
  methods: {
    selectNewStream(stream) {
      this.selectedStream = stream[0];
      if (this.selectedStream.url !== this.videoOptions.file) {
        const time = this.playerInterface?.[PLAYER_ACTIONS.getTime]?.();
        this.videoOptions = Object.assign(
            {},
            this.videoOptions,
            {
              file: this.selectedStream.url,
            },
        );

        const removeCb = this.playerInterface[PLAYER_EVENTS.loadData]?.(() => {
          this.playerInterface?.[PLAYER_ACTIONS.seek]?.(time);
          removeCb?.();
        });
        this.$once('hook:beforeDestroy', () => {
          removeCb?.();
        });
      }
    },
  },
  watch: {
    videoOptions() {
      const stream = this.streamsList.find((stream) => {
        return stream.url === this.videoOptions.file;
      });

      stream && this.selectNewStream([stream]);
    },
  },
  computed: {
    showStreamList() {
      return this.streamsList.length > 1;
    },
    streamsList() {
      const list = this.event.media.filter((item) => (
        Number(item.media_type) === Number(this.streamStatus)
      ));
      return list.map((media) => ({
        title: media.title,
        url: media.media_url,
        id: media.id,
      }));
    },
  },
};
</script>

<style lang="scss" scoped src="@/assets/css/watchPage.scss"/>
<style lang="scss" src="@/assets/css/playerPreview.scss"/>
